import { Component, type ErrorInfo, type ReactNode } from 'react';
import { ServerErrorPage } from '@/pages/error/ServerErrorPage';

interface ErrorBoundaryProps {
  children: ReactNode;
}

interface ErrorBoundaryState {
  hasError: boolean;
}

export class ErrorBoundary extends Component<ErrorBoundaryProps, ErrorBoundaryState> {
  state: ErrorBoundaryState = { hasError: false };

  static getDerivedStateFromError(): ErrorBoundaryState {
    return { hasError: true };
  }

  componentDidCatch(error: Error, errorInfo: ErrorInfo): void {
    // Route to a centralized logging service once one is provided.
    console.error('Unhandled UI error:', error, errorInfo);
  }

  private handleRetry = (): void => {
    this.setState({ hasError: false });
  };

  render(): ReactNode {
    if (this.state.hasError) {
      return <ServerErrorPage onRetry={this.handleRetry} />;
    }

    return this.props.children;
  }
}
